import React from 'react';
export const contacts = [
    {
      name: " github",
      url: "https://github.com/bus42",
      logo: <i className="fab fa-github" />
    },
    {
      name: " freeCodeCamp",
      url: "https://www.freecodecamp.org/bus42",
      logo: <i className="fab fa-free-code-camp" />
    },
    {
      name: " linkedIn",
      url: "https://www.linkedin.com/in/gregbrewton/",
      logo: <i className="fab fa-linkedin" />
    },
    {
      name: " CodePen",
      url: "https://codepen.io/Bus42/",
      logo: <i className="fab fa-codepen"></i>
    }
  ]